/**
 * @file: DeptBusiness.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 食堂楼层管理
 */
import request from '@/utils/request'

/**
 * 添加食堂(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptAdd(data) {
  return request({
    type: 'biz',
    url: 'dept/add',
    method: 'post',
    data
  })
}

/**
 * 获取AI设备信息(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptAiListGet(data) {
  return request({
    type: 'biz',
    url: 'dept/ai/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取点位下的食堂列表（大屏）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptAnchorListGet(data) {
  return request({
    type: 'biz',
    url: 'dept/anchor/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取食堂列表(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptAppletListGet(data) {
  return request({
    type: 'biz',
    url: 'dept/applet/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取食堂列表(ID和名称)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptBaseListGet(data) {
  return request({
    type: 'biz',
    url: 'dept/base/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取食堂列表(ID和名称)(不需要token)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptBaseOauthListGet(data) {
  return request({
    type: 'biz',
    url: 'dept/base/oauth/list/get',
    method: 'post',
    data
  })
}

/**
 * 删除食堂(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptDelete(data) {
  return request({
    type: 'biz',
    url: 'dept/delete',
    method: 'post',
    data
  })
}

/**
 * 根据组织ID或者部门ID，获取下属的学校（点位）-食堂关系列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptDotorgdeptListGet(data) {
  return request({
    type: 'biz',
    url: 'dept/dotorgdept/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取食堂和楼层(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptGet(data) {
  return request({
    type: 'biz',
    url: 'dept/get',
    method: 'post',
    data
  })
}

/**
 * 食堂管理获取食堂列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptListGet(data) {
  return request({
    type: 'biz',
    url: 'dept/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据所属点位，获取食堂列表(非树形)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptOrgListGet(data) {
  return request({
    type: 'biz',
    url: 'dept/org/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取有组建食堂的学校(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptOrgsimpleListGet(data) {
  return request({
    type: 'biz',
    url: 'dept/orgsimple/list/get',
    method: 'post',
    data
  })
}

/**
 * PC端获取食堂视图显示权限(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptPcPowerGet(data) {
  return request({
    type: 'biz',
    url: 'dept/pc/power/get',
    method: 'post',
    data
  })
}

/**
 * 编辑食堂开关(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptPowerUpdate(data) {
  return request({
    type: 'biz',
    url: 'dept/power/update',
    method: 'post',
    data
  })
}

/**
 * 获取食堂运行数据(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptRunInfo(data) {
  return request({
    type: 'biz',
    url: 'dept/run/info',
    method: 'post',
    data
  })
}

/**
 * 编辑食堂(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptUpdate(data) {
  return request({
    type: 'biz',
    url: 'dept/update',
    method: 'post',
    data
  })
}

/**
 * 获取年份列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptYearListGet(data) {
  return request({
    type: 'biz',
    url: 'dept/year/list/get',
    method: 'post',
    data
  })
}

/**
 * 添加楼层(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function floorAdd(data) {
  return request({
    type: 'biz',
    url: 'floor/add',
    method: 'post',
    data
  })
}

/**
 * 根据食堂ID获取楼层列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function floorBydeptListGet(data) {
  return request({
    type: 'biz',
    url: 'floor/bydept/list/get',
    method: 'post',
    data
  })
}

/**
 * 删除楼层(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function floorDelete(data) {
  return request({
    type: 'biz',
    url: 'floor/delete',
    method: 'post',
    data
  })
}

/**
 * 更新楼层(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function floorUpdate(data) {
  return request({
    type: 'biz',
    url: 'floor/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/DeptBusiness.js